import { call, put, takeEvery } from 'redux-saga/effects';
import { newDealerActionCreators, NewDealerActionKeys } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { UpdateNewDealerRequest } from '../newDealerActionTypes';
import * as api from '../newDealerApi';
import { INewDealerRequestFull } from '../newDealerInterfaces';

function* completeNewDealerRequestSaga(action: UpdateNewDealerRequest) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestFull>> = yield call(
    api.completeNewDealerRequest,
    action.payload.newDealerRequestId
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(newDealerActionCreators.setRequest(response.value.value));
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchCompleteNewDealerRequest() {
  yield takeEvery(NewDealerActionKeys.COMPLETE_NEW_DEALER_REQUEST, completeNewDealerRequestSaga);
}
